module.exports = __webpack_public_path__ + "static/media/Android.09069eb5.png";